<template>
  <div>
    <!-- nav -->
    <versionNav></versionNav>
    <!-- 目前模块为background -->
    <section class="topBg">
      <div class="inner">
        <div class="versTime">{{versTime}}</div>
        <ul class="topBg_nav">
          <li v-for="(item,index) in navList" :key="index" @click="downDown(item.id)">
            <img src="../assets/img/dian_03.png" alt srcset>
            <p>{{item.text}}</p>
          </li>
        </ul>
        <!-- <p class="taskText2">{{taskText2}}</p> -->
        <p class="taskText">{{taskText}}</p>
        <div class="linkBox clearfix">
          <div class="downloadGame">
            <a href="http://qqsm.zygames.com/t1/download.html">游戏下载</a>
          </div>
          <div class="goHome">
            <a href="http://qqsm.zygames.com/t2/main.html">官网首页</a>
          </div>
        </div>
      </div>
    </section>

<!-- 新模式 -->
    <!-- <section class="xms" id="xms"><div class="inner"></div></section> -->

<!-- 新地图 -->
    <!-- <section class="xdt" id="xdt"><div class="inner"><h2>{{newMaps.text}}</h2><p>{{newMaps.int}}</p></div></section> -->
<!-- 新地图带视频 -->
    <!-- <section class="xdt" id="xdt"><div class="inner"><h2>{{newMaps.text}}</h2><p>{{newMaps.int}}</p><videoPlayer class="myvideo"></videoPlayer></div></section> -->
    <!-- <section class="xdt" id="xdt"><div class="inner"><h2>{{newMaps.text}}</h2><p>{{newMaps.int}}</p></div></section> -->
    <!-- <video-player></video-player> -->

<!-- 新武器 -->
    <!-- <section class="xwq" id="xwq"></section> -->
    <!-- <section class="xwq" id="xwq"><h2>{{newWeapon.text}}</h2><p v-html="newWeapon.int"></p><img :src="getImg()" alt="" /></section> -->
    <!-- <section class="xwq" id="xwq"><h2>{{newWeapon.text}}</h2><p v-html="newWeapon.int"></p></section> -->
<!-- 新武器带轮播 -->
    <!-- <section class="xwq" id="xwq"><div class="inner"><xwq-tab-play></xwq-tab-play></div></section> -->

<!-- 新插件/装置 -->
    <!-- <section class="xcj" id="xcj"></section> -->

<!-- 新僚机系统 -->
    <!-- <section class="xlj" id="xlj"></section> -->

<!-- 新配方/新挂件 -->
    <section class="xpf" id="xpf"><div class="inner"><h2>{{newPF.text}}</h2><img :src="getImg()" alt="" /><p v-html="getPFInt()"></p></div></section>
    <!-- <section class="xpf" id="xpf"></section> -->

<!-- 新时装 -->
    <!-- <section class="xsz" id="xsz"></section> -->

<!-- 新装备 -->
    <!-- <section class="xzb" id="xzb"></section> -->

<!-- 靶场 -->
    <versionBc id="versionBc"></versionBc>

<!-- 周免道具 -->
    <freeProps id="freeProps"></freeProps>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import versionBc from "../components/qqsmVersion_bc.vue";
import freeProps from "../components/freeProps.vue";
import xwqTabPlay from "../components/xwqTabPlay.vue";
import videoPlayer from "../components/videoPlayer.vue";
export default {
  name: "Home",
  data() {
    return {
      navList: [
        // { text: "新地图   New Maps", id: "xdt" },
        // { text: "新武器   New Weapons", id: "xwq" },
        // { text: "新模式   New Maps", id: "xms" },
        // { text: "新僚机系统   New Wingman", id: "xlj" },
        { text: "新配方   New Formula", id: "xpf" },
        // { text: "新装置   New Formula", id: "xcj" },
        // { text: "新变身装置   New Formula", id: "xcj" },
        // { text: "新挂件   New Formula", id: "xpf" },
        // { text: "新时装   New Clothes", id: "xsz" },
        // { text: "新装备   New Clothes", id: "xzb" },
        // { text: "限时道具   New Limited", id: "versionBc" },
        { text: "免费福利   New Free", id: "freeProps" }
      ],
      // newWeapon: {text: "传承-守备官", id: "16007", int: "守备官手枪的3D打印版本，不仅重量更轻，火力也因电磁线圈的加入而暴涨，是工程六部最新一批量产化单兵防御武器的先锋。"},
      // newMaps: {text: "枪林弹雨大作战-油井争霸", id: "4", int: "茫茫大海之上，全球最大规模的石油平台群，是战争争夺的焦点。"},
      newPF: {text: "泰山Sako M90升阶", id: "2741", int: "褐色花纹装饰枪身的Sako M90。7.62mm口径突击步枪，弹匣容量30发。良好的杀伤、不错的稳定以及较高的射速是其主要特点，极高的点射精度使其在战场上表现出色。"}
    }
  },
  created(){
    // console.log('index_created')
  },
  mounted() {
    // this.cons();
    // console.log('index_mounted')
  },
  destroyed () {
  },
  computed:{
    ...mapGetters(['versTime']),
    ...mapGetters(['taskText']),
    // ...mapGetters(['taskText2'])
  },
  components: {
    versionBc, //靶场
    freeProps, //免费武器
    xwqTabPlay, //新武器轮播
    videoPlayer
  },
  methods: {
    downDown(selector) {
      var anchor = this.$el.querySelector("#" + selector);
      anchor.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    getInt() {
      var ints = this.newWeapon.int;
      var weaponInt = ints.replace(/\r\n|\n|\r|“/g, "<br/><i>").replace(/\r\n|\n|\r|”/g,"</i>");
      return weaponInt;
    },
    getPFInt() {
      var ints = this.newPF.int;
      var PFInt = ints.replace(/\r\n|\n|\r|“/g, "<br/><i>").replace(/\r\n|\n|\r|”/g,"</i>");
      return PFInt;
    },
    getImg() {
      var src = "",
        searchArr = [];
        // searchArr = this.newWeapon;
        searchArr = this.newPF;
        src = searchArr.id;
      if (!src) {
        // console.log(name);
      } else {
        return "http://cdn1.zygames.com/qqsm/t1/weapon/" + src + ".png";
      }
    }, //用require编译图片地址
    player() {
      this.$layer.open({
        type: 1,
        title: false,
        closeBtn: 1, //不显示关闭按钮
        shade: [0],
        area: ["600px", ""],
        skin: "blackBg",
        anim: 1,
        content: ` 
        <video
          class="myvideo"
          poster="../../static/myvideoBg.jpg"
          src="http://cdn1.zygames.com/qqsm/video/Mars_cutscene_2.webm"
          width="560"
          height="320"
          preload
          controls
        ></video>
      `
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.go-top{
      position: fixed;
    bottom: 120px;
    right: 20px;
    width: 50px;
    height: 50px;
    cursor: pointer;
    background: #fff;
    border-radius: 50%;
    z-index: 99;
}
.inner {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  padding-top: 1px;
}
.topBg {
  background: url("../assets/img/bg1.jpg") no-repeat top center;
  height: 1065px;
  position: relative;
  min-width: 1200px;
  .versTime {
    width: 562px;
    height: 61px;
    line-height: 61px;
    font-size: 28px;
    font-weight: 900;
    color: #e8e8e8;
    position: absolute;
    top: 420px;
    left: 50%;
    margin-left: -270px;
    background: url("../assets/img/timebg.png") no-repeat top center;
  }
  .topBg_nav {
    width: 500px;
    height: 126px;
    /* margin-top: 480px; */
    position: absolute;
    top: 500px;
    left: 50%;
    margin-left: -250px;
    text-align: left;
    li {
      width: 250px;
      height: 30px;
      float: left;
      color: #fff;
      letter-spacing: 0.1em;
      cursor: pointer;
      &:hover {
        color: #fbbe10; //red;
      }
      img {
        padding: 0 15px;
      }
      p {
        font-size: 14px;
        line-height: 37px;
        // font-weight: 100;
        display: inline-block;
        font-family: Calibri,Tahoma,"Microsoft Yahei","微软雅黑";
        text-shadow: 2px 2px 2px #000;
      }
    }
  }
  .taskText {
    font-size: 14px;
    // color: rgba(251,56,15,365);
    color: #fff;
    // color: #fff;
    text-align: center;
    font-weight: 100;
    letter-spacing: 0.1em;
    width: 800px;
    height: 60px;
    line-height: 60px;
    margin: 720px auto 0 auto;
    // background: url("../assets/img/taskTextBg.png") no-repeat top center;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 5px;
    -webkit-transition:-webkit-box-shadow linear .05s;
    //transition的过渡，对阴影部分的逐步过渡，还可以用 border linear .2s ，这是说border属性的逐步过渡，两个设置之间用 , 分隔
    border-color:rgba(255,255,255,.3);
    // -webkit-box-shadow:0 0 20px rgba(251,56,15,1);
    //box-shadow：x y 10px rgba（a，b，c，d），x y分别是阴影的方向， 然后是阴影蔓延距离，最后则是阴影部分的颜色；
    // -ms-filter:progid:DXImageTransform.Microsoft.Shadow(Strength=4, Direction=135, Color='#fb380f');
    // For IE 8
    // box-shadow:0 0 20px rgba(251,56,15,1);
    // for opera or ie9
    -webkit-box-shadow:0 0 20px rgba(255,255,255,.5);
    -ms-filter:progid:DXImageTransform.Microsoft.Shadow(Strength=4, Direction=135, Color='#fbbe10');
    box-shadow:0 0 20px rgba(255,255,255,.5);

  }
  .taskText2 {
    font-size: 14px;
    // color: rgba(251,56,15,365);
    color: #ff0;
    // color: #fff;
    text-align: center;
    font-weight: normal;
    letter-spacing: 0.1em;
    width: 800px;
    height: 60px;
    line-height: 60px;
    margin: 580px auto 0 auto;
  }
  .linkBox {
    width: 665px;
    margin: 60px auto 0;
    div {
      float: left;
      width: 258px;
      height: 85px;
      font-weight: bold;
      text-align: center;
      background-color: #274479; //#274479;
      font-size: 28px;
      padding: 2px;
      a {
        transition: 0.4s all;
        display: inline-block;
        width: 254px;
        height: 81px;
        line-height: 80px;

        color: #fff;
        border: 2px solid #385282; //#274479; //
        &:hover {
          border: 2px solid #66f; //#7f899c; //
        }
      }
    }
    div.downloadGame {
      background-color: #fbbe10;
      margin-right: 140px;
      a {
        color: #160c04;
        border: 2px solid #ffdd66;
        &:hover {
          border: 2px solid #ffff24;
        }
      }
    }
  }
}
.xwq {
  background: url("../assets/img/xwq.jpg") no-repeat top center;
  // background: url("../assets/img/bg2.jpg") no-repeat top center;
  height: 882px;
  position: relative;
  min-width: 1200px;
  padding: 50px 0;
  box-sizing: border-box;
  h2{
    // background: url("../assets/img/xwq.png") no-repeat top center;
    width: 941px;
    height: 165px;
    margin: 0px auto;
    color: #C00;
    font: bold 42px/250px "微软雅黑","Microsoft Yahei";
  }
  p {
    width: 640px;
    margin: 10px auto;
    font-size: 16px;
    color: #333;
    text-align: center;
    line-height: 200%;
    i {
      font-weight: bold;
      color: red;
    }
  }
  
  img {
    max-width: 890px;
    max-height: 400px;
    // -webkit-filter: drop-shadow(-30px -20px 5px rgba(0, 0, 0, 0.4));
    // fliter:drop-shadow(-30px -20px 5px rgba(0,0,0,0.4));
    // fliter:drop-shadow(-30px -20px 5px #ccc);
  }
}
.xzb {
  background: url("../assets/img/xzb.jpg") no-repeat top center;
  height: 885px;
  position: relative;
  min-width: 1200px;
}
.xlj {
  background: url("../assets/img/xlj.jpg") no-repeat top center;
  height: 885px;
  position: relative;
  min-width: 1200px;
}
.xpf {
  // background: url("../assets/img/xpf.jpg") no-repeat top center;
  background: url("../assets/img/xwqbg.jpg") no-repeat top center;
  height: 885px;
  position: relative;
  min-width: 1200px;
  h2{
    width: 941px;
    // height: 165px;
    margin: 156px auto 0;
    color: #C00;
    font: bold 42px/42px "微软雅黑","Microsoft Yahei";
  }
  p {
    width: 640px;
    margin: 50px auto;
    font-size: 16px;
    color: #666;
    text-align: center;
    line-height: 200%;
    i {
      font-weight: bold;
      color: red;
    }
  }
  img {
      max-width: 890px;
      max-height: 400px;
      margin: 50px auto;
      -webkit-filter: drop-shadow(-30px -20px 5px rgba(0, 0, 0, 0.4));
      fliter:drop-shadow(-30px -20px 5px rgba(0,0,0,0.4));
      fliter:drop-shadow(-30px -20px 5px #ccc);
    }
}
.xms {
  background: url("../assets/img/xms.jpg") no-repeat top center;
  height: 899px;
  position: relative;
  min-width: 1200px;
}
.xdt {
  background: url("../assets/img/xdt.jpg") no-repeat top center;
  height: 899px;
  position: relative;
  min-width: 1200px;
  h2{
    width: 941px;
    // height: 165px;
    margin: 172px auto 0;
    color: #C00;
    font: bold 42px/42px "微软雅黑","Microsoft Yahei";
  }
  p {
    width: 941px;
    margin: 20px auto 0;
    font-size: 16px;
    color: #666;
    text-align: center;
  }
}
.xsz {
  background: url("../assets/img/xsz.jpg") no-repeat top center;
  height: 900px;
  position: relative;
  min-width: 1200px;
}
.xcj {
  background: url("../assets/img/xcj.jpg") no-repeat top center;
  height: 921px;
  position: relative;
  min-width: 1200px;
}

/**/
.myvideo {
  margin: 30px auto 0;
  width: 79px;
  height: 69px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue